import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  Solutions,
  PainPoints,
  CaseStudy,
  Process,
  ConversionZone,
} from './components';
import WhatsAppFloat from './components/WhatsAppFloat';
import { PAGE_TITLE, PAGE_DESCRIPTION } from './cherrySoftwareContent';
import { CHERRY_SOFTWARE_CONTAINER_PROPS } from './cherrySoftwareLayout';
import { CherryDevTheme } from './CherryDevTheme';
import { CHERRY_DEV } from './cherryDevBrand';

const LandingCherrySoftwareInner = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', PAGE_DESCRIPTION);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: CHERRY_DEV.cream,
        fontFamily: '"Outfit", "Segoe UI", system-ui, sans-serif',
      }}
    >
      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS} paddingX={0} paddingY={{ xs: 3, sm: 4, md: 6 }}>
          <Hero />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Solutions />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <PainPoints />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <CaseStudy />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <Process />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <ConversionZone />
      </Container>

      <WhatsAppFloat />
    </Box>
  );
};

const LandingCherrySoftware = () => (
  <CherryDevTheme>
    <LandingCherrySoftwareInner />
  </CherryDevTheme>
);

LandingCherrySoftware.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingCherrySoftware;
